import { render, staticRenderFns } from "./EditClassDialog.vue?vue&type=template&id=dade1d1e&lang=pug"
import script from "./EditClassDialog.vue?vue&type=script&lang=js"
export * from "./EditClassDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports